

export enum AppointmentStatus {
}

export enum AppointmentStatus {
}

export enum AppointmentType {
}

/**
 * Backend `messageCode` values — the single declaration for the whole repo.
 *
 * This used to be duplicated: a SCREAMING_SNAKE copy lived in
 * `app/shared/model/common.model` (later moved to `enums/http-message-code.enum.ts`)
 * carrying the same numeric values under different member spellings, which made
 * `response.messageCode === HttpMessageCode.X` fail to type-check across the two.
 * They are now merged into this one enum under the repo's PascalCase convention;
 * `@shared/model/common.model` re-exports it so existing import paths keep working.
 *
 * Do not re-declare these codes anywhere else — import from `@core/enums`.
 */
export enum HttpMessageCode {
    AccessDenied = 545,
    EcosystemAccessDenied = 594,
}
export enum JsTypeof {
    String = 'string',
    Object = 'object',
}

export enum EntityType {
    Doctor = 'doctor',
    Laboratory = 'laboratory',
    Radio = 'radio',
}

export enum NgxOtpStyleAdderMethod {
    AddStyleToAll = 'addStyleToAll',
    AddStyle = 'addStyle',
}
